import React, { Component } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
  Brush,
} from "recharts";
import themeLarge from "../../component/ThemeLarge";

class PathHitsOverTimeChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPath: null,
    };
  }

  componentDidMount() {
    const grouped = this.groupHitsByDate();
    const firstPath = Object.keys(grouped)[0] || null;
    this.setState({ selectedPath: firstPath });
  }

  groupHitsByDate = () => {
    const rawEntries = Object.values(this.props.groupedMetrics || {})
      .flat()
      .filter((entry) => entry.path && entry.timestamp);

    const grouped = {};

    rawEntries.forEach((entry) => {
      const path = entry.path || "Unknown";

      const dateObj =
        entry.timestamp instanceof Date
          ? entry.timestamp
          : entry.timestamp.toDate?.() || new Date();

      const dateStr = dateObj.toISOString().split("T")[0]; // "YYYY-MM-DD"

      if (!grouped[path]) grouped[path] = {};
      if (!grouped[path][dateStr]) grouped[path][dateStr] = 0;

      grouped[path][dateStr] += 1;
    });

    return grouped; // { "/projects": { "2025-05-25": 3, ... }, ... }
  };

  render() {
    const hitsGrouped = this.groupHitsByDate();
    const { selectedPath } = this.state;
    const paths = Object.keys(hitsGrouped);

    const chartData = selectedPath
      ? Object.entries(hitsGrouped[selectedPath])
          .map(([date, count]) => ({ date, count }))
          .sort((a, b) => new Date(a.date) - new Date(b.date))
      : [];

    return (
      <div className="mt-5">
        <h5 style={{ color: themeLarge.colors.primary }}>
          📈 Daily Hits per Path
        </h5>
        <p style={{ fontSize: "0.9rem" }}>
          Select a path to see daily hit trends.
        </p>

        {/* Dropdown */}
        <select
          value={selectedPath || ""}
          onChange={(e) => this.setState({ selectedPath: e.target.value })}
          className="form-select mb-3"
          style={{ maxWidth: "300px", fontFamily: "Kumbh Sans" }}
        >
          {paths.map((path) => (
            <option key={path} value={path}>
              {path}
            </option>
          ))}
        </select>

        {/* Line Chart */}
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="count"
              stroke={themeLarge.colors.primary}
              name="Hits"
              dot={{ r: 3 }}
            />
            <Brush dataKey="date" height={30} stroke={themeLarge.colors.primary} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default PathHitsOverTimeChart;
